export const SYSTEM_OF_MEASURES = {
  SI: 'si',
  SI_CL: 'si_cl',
  IMPERIAL: 'imperial',
};

export const UNIT_TYPES = {
  BODY_WEIGHT: {
    SI: 'kg',
    SI_CL: 'kg',
    IMPERIAL: 'lb',
  },
  LENGTH_BODY_MEASUREMENT: {
    SI: 'cm',
    SI_CL: 'cm',
    IMPERIAL: 'in',
  },
  VOLUME: {
    SI: 'ml',
    SI_CL: 'cl',
    IMPERIAL: 'oz',
  },
  PERCENTAGE: {
    // Backend expects the body-fat percentage unit as `pct`, not `%`.
    // The `%` shown in the form UI is hardcoded separately (MeasurementForm).
    SI: 'pct',
    SI_CL: 'pct',
    IMPERIAL: 'pct',
  },
  LEVEL: {
    SI: 'lvl',
    SI_CL: 'lvl',
    IMPERIAL: 'lvl',
  },
};
